module.exports = __webpack_public_path__ + "static/media/BlackOps7.ad4eea3f.png";